import { Box, useTheme } from "@mui/material"
import { useMemo } from "react"

import { getIcon } from "utils/icon"

import { useTranslation } from "providers/i18n"
import { useService } from "hooks/service/useService"

import { PageLayout } from "layouts/PageLayout"

import { EmptyData } from "components/EmptyData"
import { Head } from "components/Head"
import { MotionDiv, showContent } from "components/motions"
import { ServiceCard } from "components/domains/service/ServiceCard"
import { ServiceIcon } from "components/icons"

export const ServicePage = ({ Layout = PageLayout, AppNavigation }) => {
  const { t } = useTranslation({ defaultValue: null })
  const { services, hasData } = useService()

  const theme = useTheme()

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.service) || <ServiceIcon />,
    [theme]
  )

  const { root, gridItem, gridContainer, emptyDataContainer, pageLayout } =
    theme.components?.[`ServicePage`]?.styleOverrides || {}

  return (
    <>
      <Head title={t("Service & Privilege")} />
      <Layout sx={pageLayout} AppNavigation={AppNavigation}>
        <MotionDiv
          variants={showContent}
          initial="initial"
          animate="animate"
          sx={root}
        >
          {hasData ? (
            <Box sx={gridContainer}>
              {services.map((service, index) => (
                <ServiceCard
                  sx={gridItem}
                  key={`service-item-${index}`}
                  data={service}
                />
              ))}
            </Box>
          ) : (
            <Box sx={emptyDataContainer}>
              <EmptyData
                icon={emptyIcon}
                primary={t("Coming soon")}
                secondary={t("Stay tuned for the update")}
              />
            </Box>
          )}
        </MotionDiv>
      </Layout>
    </>
  )
}
